import React from 'react';
import RecipeCategory from '../../components/RecipeCourse/RecipeCategory';
const currentPath = window.location.href;

const Recipes = () => {
  return <RecipeCategory currentPath={currentPath} />;
};

export default Recipes;
